"use strict";
import Vue     from 'vue/dist/vue.common.js';
import Tooltip from 'tooltip.js';

const Popper = Vue.component('ts-popper', {
  props: {
    content: {
      require: true,
      type: String
    }
  },
  template: `
    <button>
      <slot></slot>
    </button>
  `,

  mounted() {
    // Create a empty element to insert the tooltip content into
    let el = document.createElement('div');
    el.innerHTML = this.content;

    // Create the tooltip
    const tooltip = new Tooltip(this.$el, {
        title: el,
        html: true, // allow html content
        trigger: "click",
    });

    // Add event to close the tooltip when the body is clicked
    document.addEventListener('click', ()=> {
      tooltip.hide()
    })
  }
})